import { IAction } from "../../../interface/action.interface";
import { IDownloadRequest } from "../../../pages/data-browser/interface/download-request";

export enum DownloadActionType {
    DOWNLOAD_START = "DOWNLOAD_START",
    DOWNLOAD_LIST_LOCATIONS = "DOWNLOAD_LIST_LOCATIONS",
    DOWNLOAD_SUBLIST_LOCATIONS = "DOWNLOAD_SUBLIST_LOCATIONS",
    DOWNLOAD_LIST_SNAPSHOT_LOCATIONS = "DOWNLOAD_LIST_SNAPSHOT_LOCATIONS",
    DOWNLOAD_DATA_BROWSER = "DOWNLOAD_DATA_BROWSER",
}

export interface IDownloadStartAction extends IAction {
    type: DownloadActionType.DOWNLOAD_START;
    payload: {
        downloadUrl: string;
        requestBody?: string;
    };
}

export interface IDownloadListLocationsAction extends IAction {
    type: DownloadActionType.DOWNLOAD_LIST_LOCATIONS;
    payload: {
        listId: number;
    };
}

export interface IDownloadSubListLocationsAction extends IAction {
    type: DownloadActionType.DOWNLOAD_SUBLIST_LOCATIONS;
    payload: {
        listId: number;
    };
}

export interface IDownloadListSnapshotLocationsAction extends IAction {
    type: DownloadActionType.DOWNLOAD_LIST_SNAPSHOT_LOCATIONS;
    payload: {
        listId: number;
        date: string;
    };
}

export interface IDownloadDataBrowserAction extends IAction {
    type: DownloadActionType.DOWNLOAD_DATA_BROWSER;
    payload: {
        request: IDownloadRequest;
    };
}

export const downloadStartAction = (
    downloadUrl: string,
    requestBody?: string,
): IDownloadStartAction => ({
    type: DownloadActionType.DOWNLOAD_START,
    payload: {
        downloadUrl,
        requestBody,
    },
});

export const downloadListLocationsAction = (
    listId: number,
): IDownloadListLocationsAction => ({
    type: DownloadActionType.DOWNLOAD_LIST_LOCATIONS,
    payload: {
        listId,
    },
});

export const downloadListSnapshotLocationsAction = (
    listId: number,
    date: string,
): IDownloadListSnapshotLocationsAction => ({
    type: DownloadActionType.DOWNLOAD_LIST_SNAPSHOT_LOCATIONS,
    payload: {
        listId,
        date,
    },
});

export const downloadSubListLocationsAction = (
    listId: number,
): IDownloadSubListLocationsAction => ({
    type: DownloadActionType.DOWNLOAD_SUBLIST_LOCATIONS,
    payload: {
        listId,
    },
});

export const downloadDataBrowserAction = (
    request: IDownloadRequest,
): IDownloadDataBrowserAction => ({
    type: DownloadActionType.DOWNLOAD_DATA_BROWSER,
    payload: {
        request,
    },
});

export type IDownloadAction =
    | IDownloadStartAction
    | IDownloadListLocationsAction
    | IDownloadSubListLocationsAction
    | IDownloadListSnapshotLocationsAction
    | IDownloadDataBrowserAction;
